import { useEffect } from 'react'
import { authApi } from '@/modules/auth/services/auth-api'
import { useAuthStore } from '@/store/use-auth-store'

const REFRESH_SKEW_MS = 60_000
const MIN_REFRESH_DELAY_MS = 30_000

export function useSessionBootstrap(): void {
  const status = useAuthStore((state) => state.status)
  const expiresAt = useAuthStore((state) => state.expiresAt)
  const setSession = useAuthStore((state) => state.setSession)
  const clearSession = useAuthStore((state) => state.clearSession)

  useEffect(() => {
    if (status !== 'loading') {
      return
    }

    let active = true

    authApi
      .refreshSession()
      .then((response) => {
        if (active) {
          setSession(response.data)
        }
      })
      .catch(() => {
        if (active) {
          clearSession()
        }
      })

    return () => {
      active = false
    }
  }, [status, setSession, clearSession])

  useEffect(() => {
    if (status !== 'authenticated' || !expiresAt) {
      return
    }

    const refreshDelay = Math.max(expiresAt - Date.now() - REFRESH_SKEW_MS, MIN_REFRESH_DELAY_MS)
    const timeout = window.setTimeout(() => {
      authApi
        .refreshSession()
        .then((response) => setSession(response.data))
        .catch(() => clearSession())
    }, refreshDelay)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [status, expiresAt, setSession, clearSession])
}
